import { ReactNode } from "react"
import { useLocation } from "react-router-dom"
import Header from "@/components/layout/Header"
import ChatSupport from "@/components/ChatSupport"
import PublicFooter from "@/components/public-home/PublicFooter"
import PublicHeader from "@/components/public-home/PublicHeader"
import "@/components/public-home/public-home.css"
import Footer from "./Footer"
import MobileBottomNav from "./MobileBottomNav"
import "@/styles/mobile.css"

interface MainLayoutProps {
	children: ReactNode
}

export default function MainLayout({ children }: MainLayoutProps) {
	const { pathname } = useLocation()
	const isGuestStoreEntry = pathname === "/schedule-pickup/store-details"
	const usesFocusedAppShell =
		(pathname.startsWith("/schedule-pickup") && !isGuestStoreEntry) ||
		pathname.startsWith("/member") ||
		pathname.startsWith("/membership") ||
		pathname === "/dfw"
	const isPublicHomepage = pathname === "/"
	const usesPublicMarketingShell = [
		"/how-it-works",
		"/store-selection",
		"/retailer-onboarding",
		"/help-center",
		"/about-us",
		"/platform-services",
		"/delivery-info",
		"/team",
		"/robot-leasing",
		"/terms-and-conditions",
		"/privacy-policy",
		"/accessibility",
	].includes(pathname) || pathname.startsWith("/returns") || isGuestStoreEntry
	const isAuthExperience = [
		"/auth",
		"/login",
		"/signin",
		"/register",
		"/signup",
		"/account-setup",
		"/re-authenticate",
		"/forgot-password",
		"/reset-password",
		"/verify-email",
	].includes(pathname)
	const showMobileBottomNav =
		pathname !== "/" &&
		!pathname.startsWith("/admin") &&
		!isAuthExperience &&
		!usesFocusedAppShell &&
		!usesPublicMarketingShell

	return (
		<div
			data-site-shell
			className={`flex min-h-screen w-full flex-col ${
				showMobileBottomNav
					? "pb-[calc(5rem+var(--site-safe-area-bottom))] md:pb-0"
					: ""
			}`}
		>
			{usesPublicMarketingShell && <PublicHeader />}
			{!usesFocusedAppShell && !isPublicHomepage && !usesPublicMarketingShell && <Header />}
			<div
				data-site-content={!usesFocusedAppShell && !isPublicHomepage ? "" : undefined}
				className={
					usesFocusedAppShell || isPublicHomepage
						? ""
						: usesPublicMarketingShell
							? "site-global-content mt-[68px] min-[1025px]:mt-[54px]"
							: "site-global-content mt-[82px]"
				}
			>
				{/* <Sidebar /> */}
				<main className="flex-1 bg-white min-h-[calc(100vh-310px)]">
					{children}
				</main>
			</div>
			{usesPublicMarketingShell && !isGuestStoreEntry && <PublicFooter />}
			{!usesFocusedAppShell && !isPublicHomepage && !usesPublicMarketingShell && !isAuthExperience && <Footer />}
			{showMobileBottomNav && <MobileBottomNav />}
			{!usesFocusedAppShell && !isPublicHomepage && !usesPublicMarketingShell && !isAuthExperience && <ChatSupport />}
		</div>
	)
}
